import * as React from "react";

function ArrowDownArrowUpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M206.4 335.1 152 394.9V56.02C152 42.76 141.3 32 128 32s-24 10.76-24 24.02v338.9l-54.37-58.95c-4.719-5.125-11.16-7.719-17.62-7.719-5.812 0-11.66 2.094-16.28 6.375-9.75 8.977-10.34 24.18-1.344 33.94l95.1 104.1c9.062 9.82 26.19 9.82 35.25 0l95.1-104.1c9-9.758 8.406-24.96-1.344-33.94-7.992-9.126-23.192-8.426-32.092.474zm227.2-191.7L338.5 39.3c-9.062-9.82-26.19-9.82-35.25 0L206.4 143.4c-9 9.758-8.406 24.96 1.344 33.94a23.878 23.878 0 0 0 16.28 6.375c6.469 0 12.91-2.594 17.62-7.719L296 117.1V456c0 13.2 10.8 24 24 24s24-10.76 24-24.02V117.1l54.37 58.95c8.938 9.758 24.12 10.41 33.9 1.344C442 168.4 442.6 153.2 433.6 143.4z"
  }));
}

const ForwardRef = React.forwardRef(ArrowDownArrowUpIcon);
export default ForwardRef;